import { useState } from "react";
import { Form, Button } from "react-bootstrap";
// import { Rating } from "react-simple-star-rating";
import styles from "./styles.module.css";

const FilterBox = ({ applyFilter, onResetFilters }) => {
  const [price, setPrice] = useState({ minprice: "", maxprice: "" });
  const [rating, setRating] = useState("");
  const [condition, setCondition] = useState("");

  const handlePrice = (e) => setPrice({ ...price, [e.target.name]: e.target.value });

  const resetAll = () => {
    setPrice({ minprice: "", maxprice: "" });
    setRating("");
    setCondition("");
    if (onResetFilters) onResetFilters();
  };

  return (
    <aside className={styles.root}>
      <div className={styles.inner}>
        <h3 className={styles.heading}>Price</h3>
        <div className={styles.fieldRow}>
          <Form.Control
            type="number"
            name="minprice"
            placeholder="Min"
            value={price.minprice}
            onChange={handlePrice}
            className={styles.input}
          />
          <Form.Control
            type="number"
            name="maxprice"
            placeholder="Max"
            value={price.maxprice}
            onChange={handlePrice}
            className={styles.input}
          />
        </div>

        {/* Rating UI can be re-enabled later */}

        <h3 className={styles.heading}>Condition</h3>
        <div className={styles.badgeGroup}>
          {["New"].map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCondition(c)}
              className={`${styles.badge} ${condition === c ? styles.badgeActive : ""}`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className={styles.actions}>
          <Button
            type="button"
            variant="primary"
            className={styles.btn}
            onClick={() => applyFilter(price.minprice, price.maxprice, rating, condition)}
          >
            Apply Filter
          </Button>
          <Button type="button" variant="outline-secondary" className={styles.btn} onClick={resetAll}>
            Reset
          </Button>
        </div>
      </div>
    </aside>
  );
};

export default FilterBox;
